import { Controller } from '@hotwired/stimulus';

import BoletoWatcher from '@/modules/boleto_watcher';
import Checkout from '@/modules/checkout';
import ModuleLoader from '@/modules/module_loader';

export default class extends Controller {
  connect() {
    const options = ModuleLoader.getOptions();

    new Checkout(options).create();
    new BoletoWatcher(options).create();
  }
}
